
.container {
  display: flex;
  align-items: center;
  gap: map.get($spacing-scale, 'sm');
  padding: map.get($spacing-scale, 'md');
  width: 100%;
  height: 52px;

  border: 1px solid var(--color-grey-neutral);
  border-radius: map.get($radius, 'md');
  background-color: transparent;

  @include transition(border-color, background-color);
}

// Size variants
.slim {
  height: 34px;
  padding: map.get($spacing-scale, 's-2') map.get($spacing-scale, 'sm'); // 8px 12px
  gap: map.get($spacing-scale, 's-2'); // 8px

  .field {
    @include metadata-regular;
  }

  .leadingIcon {
    width: 14px;
    height: 14px;
  }

  .clearButton {
    width: 14px;
    height: 14px;
  }
}

// State variants
.hovered {
  border-color: var(--color-grey-dark);
}

.focused {
  border-color: var(--color-primary-base);
  outline: none;
}

.disabled {
  background-color: var(--color-grey-light);
  border-color: var(--color-grey-neutral);
  cursor: not-allowed;
  opacity: 0.6;
}

.error {
  border-color: var(--color-semantic-danger);
}

// Error message below input
.errorMessage {
  @include metadata-regular;
  color: var(--color-semantic-danger);
  margin: map.get($spacing-scale, 'xs') 0 0;
}

// Input field
.field {
  border: none;
  background: none;
  outline: none;
  margin: 0;
  padding: 0;

  flex: 1;
  min-width: 0;

  @include body-small-regular;
  color: var(--color-text-primary);

  &::placeholder {
    color: var(--color-text-tertiary);
  }

  &:disabled {
    cursor: not-allowed;
    color: var(--color-text-secondary);
  }
}

// Leading icon
.leadingIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  color: var(--color-text-tertiary);

  svg,
  img {
    width: 100%;
    height: 100%;
    display: block;
  }
}

// Clear button
.clearButton {
  border: none;
  background: none;
  margin: 0;
  padding: 0;
  cursor: pointer;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 18px;
  height: 18px;

  color: var(--color-grey-dark);

  @include transition(color);

  &:hover {
    color: var(--color-text-primary);
  }

  &:active {
    color: var(--color-text-secondary);
  }

  svg {
    width: 100%;
    height: 100%;
    display: block;
  }
}
